module.exports = __webpack_public_path__ + "media/images/action-heart-7b876fae7a2fcd83ef80b3cad9b5ee43.svg";